import { KeyValue } from 'src/app/shared/models/model/concretes/shared/key-value.model';

export type OfferState = {
  selected_offer: string;
  coupon_code: string;
  sponsor_email: string;
  mensual_price: string;
  highlighted?: boolean;
  reference_devis: string;
  type_promotion: string;
  options: OptionState | null;
  renforcement: ReinforcementState | null;
  insurerResiliation: boolean;
  lessorNotificationAttestation: boolean;
  lessorAdditionalInformation: LessorAdditionalInformation | null;
  resiliationConcurrence: string | null;
  resiliationAssureur: PreviousInsuranceState | null;
  policyInsuranceActual: string | null;
};

export const initialOptionState: OptionState = {
  schoolInsurance: {
    children: [],
  },
};

export const initialOfferState: OfferState = {
  selected_offer: '',
  coupon_code: '',
  sponsor_email: '',
  mensual_price: '',
  highlighted: false,
  reference_devis: '',
  type_promotion: '',
  options: initialOptionState,
  renforcement: null,
  insurerResiliation: false,
  lessorNotificationAttestation: false,
  lessorAdditionalInformation: null,
  resiliationConcurrence: null,
  resiliationAssureur: null,
  policyInsuranceActual: null,
};

export interface PreviousInsuranceState {
  insurerName: string;
  insurerAddress: string;
  insurerZipCode: string;
  insurerCity: string;
  insurancePolicyNumber: string;
}
export interface OptionState {
  schoolInsurance: SchoolInsuranceState;
}

export interface ReinforcementState {
  objectValue: KeyValue[];
  furniture: KeyValue[];
}

export interface LessorAdditionalInformation {
  name: string;
  email: string;
  LogementOccupe: boolean | null;
  Reference1: string;
  Reference2: string;
}

// #region School Insurance
export interface SchoolInsuranceState {
  children: ChildInfo[];
}

export interface ChildInfo {
  firstName: string | null;
  lastName: string | null;
  birthDate: string | null;
}
// #endregion
